<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          ref="dataTable"
          title="Protocol roles"
          upsert-max-width="850px"
          :subtitle="protocol.name"
          :config="config"
          @sitecode='sitecode'
          :hidden-fields="{ protocol_id }"
          :filters="{ protocol_id }">
          <template slot='headerActions'>
            
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                  <v-btn
                    v-on="on"
                    color="secondary"
                    @click="$router.go(-1)">
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>   
                </template>
              <span>Back</span>
            </v-tooltip>   

            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  v-if="$can('export', 'roles')"
                  color="secondary"
                  @click="export_excel">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Export Excel</span>
            </v-tooltip>

            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  v-if="$can('import', 'roles')"
                  color="secondary"
                  :loading="loadingImport"
                  @click="pickFile">
                  <v-icon>mdi-upload</v-icon>
                </v-btn>
              </template>
              <span>Import CSV</span>
            </v-tooltip>

          </template>
        </core-table>

      </v-flex>

      <input
        id="file"
        ref="file"
        type="file"
        style="display: none"
        accept=".xls, .xlsx, .csv"
        @change="handleFileUpload()"
      />

    </v-layout>
  </v-container>
</template>

<script>
import XLSX from "xlsx"
import config from './config_index.js'
import { export_data } from '@/api/export.js'
import { getDetail, upsert } from '@/api/base_entity'
export default {
  data () {
    return {
      config,
      protocol: {},
      protocol_id: null,
      site_id: null,
      openSitecode: false,
      loadingExport: {excel:false},
      loadingImport: false
    }
  },
  async created () {
    this.protocol_id= Number(this.$route.params.protocolId)
    this.protocol = await getDetail('protocol', this.$route.params.protocolId)
  },
  methods: {
    sitecode (item) {
      this.site_id = item.site_id
      this.openSitecode = true
    },
    pickFile() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.loadingImport = true
      const reader = new FileReader();
      reader.onload = this.processExcel;
      reader.readAsBinaryString(file);
    },
    processExcel(e) {

      setTimeout(() => { // questo per rendere il blocco async
        const data = e.target.result;

        // Questa fottuta è bloccante
        const wb = XLSX.read(data, { type: "binary",  cellDates: true });
        const first_sheet = wb.SheetNames[0];

        // Override Date obj toJSON to format date (YYYY-MM-DD)
        Date.prototype.toJSON = function() {

            var month = '' + (this.getMonth() + 1),
            day = '' + this.getDate(),
            year = this.getFullYear();

            if (month.length < 2) {
              month = '0' + month;
            }

            if (day.length < 2) {
              day = '0' + day;
            }

            return [year, month, day].join('-');
        };

        // Check !ref 
        delete wb.Sheets[first_sheet]['!margins'];
        const ref = wb.Sheets[first_sheet]['!ref'];
        delete wb.Sheets[first_sheet]['!ref'];

        const refEl = ref.split(':');
        // const refLatestRow = refEl[1].match(/(\d+)/)[0]; 
        const refLatestCol = refEl[1].replace(/[0-9]/g, '');

        const sheetKeys = Object.keys(wb.Sheets[first_sheet]);
        let maxRow = 0;

        sheetKeys.map( el => {
          if (el[0] == '!') {
            return;
          }
          try {
            var n = parseInt(el.match(/(\d+)/)[0]);
            maxRow = maxRow < n ? n : maxRow;
          } catch(e) {
            console.log(e, el)
          }
        });

        const newRef = refEl[0] + ':' + refLatestCol + maxRow;
       
        wb.Sheets[first_sheet]['!ref'] = ref;

        if ( newRef != ref) {
           const message = 'This excel appears to be corrupt, SafetyDB has fix it, please check the data integrity!';
           this.$root.$emit("openSnackbar", {
              message,
              color: "error"
            });
          
          wb.Sheets[first_sheet]['!ref'] = newRef;
        }

        if (sheetKeys.length > 2000000) {
          const message = "Spreadsheet is too long! Pleae verify the empty rows.";
          // this.$store.dispatch("app/openAlert", {message});
          this.$root.$emit("openSnackbar", {
            message,
            color: "error"
          });
          
          this.loadingImport = false
          return;
        }

        const rows = XLSX.utils.sheet_to_json(wb.Sheets[first_sheet], {
          header: 1,
          blankRows: false,
          defval: "",
        });

        if (!rows.length) {
          const message = "Spreadsheet is empty!";
          // this.$store.dispatch("app/openAlert", {message});
          this.$root.$emit('openSnackbar', {
            message,
            color: 'error'
          })
          this.loadingImport = false
          return
        }

        upsert('import_roles', {rows, protocol_id:this.protocol_id}).then( () => {
          this.$refs.dataTable.getData();
          this.$root.$emit("openSnackbar", {
            message:"Roles imported correctly!",
            color: "success"
          });
        }).catch( e => {
          this.$root.$emit('openSnackbar', {
            message: e.response.data.message,
            color: 'error'
          })
        })
        .finally( () => {
            this.loadingImport = false
        })

        this.$refs.file.value = '';
        
      }, 50);
    
      
      // this.loading = false;
      // this.$store.dispatch("app/stopLoading");
      //this.initDataset(rows);
    },
    export_excel() {
      this.loadingExport['excel'] = true
      export_data('roles/' + this.protocol_id, 'excel').then( () => {
        this.loadingExport['excel'] = false
      }).finally( () => {
        this.loadingExport['excel'] = false
      })
    }
  }
}
</script>
